import React, { useState, useEffect } from "react"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import { FaCircle } from "react-icons/fa"
import {
  Modal,
  ModalBody,
  ModalHeader,
  Table,
  Spinner,
  Badge,
} from "reactstrap"
import dayjs from "dayjs"

import { withRouter, Link } from "react-router-dom"
import userStore from "userStore"
import { getUsuarioMe } from "../../../api/agro"

const UserInfoModal = ({ isOpen, toggle }) => {
  const currentUser = userStore(state => state.user)
  const [userData, setUserData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isOpen && currentUser?.username) {
      setLoading(true)
      getUsuarioMe()
        .then(data => setUserData(data || null))
        .catch(() => setUserData(null))
        .finally(() => setLoading(false))
    }
  }, [isOpen, currentUser?.username])

  const formatDate = date =>
    date ? dayjs(date).format("DD/MM/YYYY HH:mm") : "—"

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>Info del usuario</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner />
          </div>
        ) : userData ? (
          <Table bordered className="mb-0">
            <tbody>
              <tr>
                <th className="bg-light" style={{ width: "140px" }}>
                  Usuario
                </th>
                <td>{userData.usuario}</td>
              </tr>
              <tr>
                <th className="bg-light">Nombre</th>
                <td>{userData.nombre}</td>
              </tr>
              <tr>
                <th className="bg-light">Apellido</th>
                <td>{userData.apellido}</td>
              </tr>
              <tr>
                <th className="bg-light">Estado</th>
                <td>
                  <Badge color={userData.habilitado ? "success" : "danger"}>
                    {userData.habilitado ? "Activo" : "Deshabilitado"}
                  </Badge>
                </td>
              </tr>
              <tr>
                <th className="bg-light">Sucursal</th>
                <td>{userData.sucCodigo ?? "—"}</td>
              </tr>
              <tr>
                <th className="bg-light">Fecha alta</th>
                <td>{formatDate(userData.fechaAlta)}</td>
              </tr>
              <tr>
                <th className="bg-light">Último ingreso</th>
                <td>{formatDate(userData.fechaUltIngreso)}</td>
              </tr>
              <tr>
                <th className="bg-light">
                  Perfiles ({userData.perfiles?.length ?? 0})
                </th>
                <td>
                  {userData.perfiles?.map((p, i) => (
                    <div key={i} className="mb-1">
                      <span className="badge badge-soft-primary font-size-11 me-1">
                        {p.descripcion}
                      </span>
                      {p.admin && (
                        <span className="badge badge-soft-warning font-size-11 me-1">
                          Admin
                        </span>
                      )}
                      <span
                        className={`font-size-10 ${p.vigente ? "text-success" : "text-danger"}`}
                      >
                        {p.vigente ? "Vigente" : "No vigente"}
                      </span>
                    </div>
                  ))}
                  {(!userData.perfiles || userData.perfiles.length === 0) && (
                    <span className="text-muted">Sin perfiles asignados</span>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <p className="text-muted mb-0">
            No se pudieron cargar los datos del usuario.
          </p>
        )}
      </ModalBody>
    </Modal>
  )
}

const ProfileMenu = () => {
  const [menu, setMenu] = useState(false)
  const [infoModal, setInfoModal] = useState(false)
  const user = userStore(state => state.user)

  return (
    <div className="d-flex align-items-center">
      <UserInfoModal
        isOpen={infoModal}
        toggle={() => setInfoModal(!infoModal)}
      />
      <div className="d-flex align-items-center gap-2">
        <FaCircle size={5} className="text-success" />
        <p className="mb-0">{user?.name}</p>
      </div>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="bx bx-user font-size-24 align-middle me-1" />
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <button
            className="dropdown-item"
            onClick={() => {
              setMenu(false)
              setInfoModal(true)
            }}
          >
            <i className="bx bx-info-circle font-size-16 align-middle me-1 text-primary" />
            <span>Info del usuario</span>
          </button>
          <Link to="/cambiar-clave" className="dropdown-item">
            <i className="bx bx-key font-size-16 align-middle me-1 text-primary" />
            <span>Cambiar clave</span>
          </Link>
          <div className="dropdown-divider" />
          <Link to="/cerrar-sesion" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>Cerrar sesión</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

export default withRouter(ProfileMenu)
